/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { clamp as t } from "./mathUtils.js";
import { replace as n } from "./string.js";
import { preferredMetricLengthUnit as i, convertUnit as r, preferredMetricVerticalLengthUnit as o, preferredImperialLengthUnit as u, preferredImperialVerticalLengthUnit as e, preferredMetricAreaUnit as s, preferredImperialAreaUnit as c } from "./unitUtils.js";
import { formatNumber as m } from "../intl/number.js";

function a(t, n, i) {
  return t.units[n][i];
}

function f(t, n, i) {
  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
  var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "abbr";
  return "".concat(m(n, {
    minimumFractionDigits: r,
    maximumFractionDigits: r
  }), " ").concat(a(t, i, o));
}

function b(t, n, o) {
  var u = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
  var e = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "abbr";
  var s = i(n, o);
  return f(t, r(n, o, s), s, u, e);
}

function l(t, n, i) {
  var u = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
  var e = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "abbr";
  var s = o(n, i);
  return f(t, r(n, i, s), s, u, e);
}

function g(t, n, i) {
  var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
  var e = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "abbr";
  var s = u(n, i);
  return f(t, r(n, i, s), s, o, e);
}

function F(t, n, i) {
  var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
  var u = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "abbr";
  var s = e(n, i);
  return f(t, r(n, i, s), s, o, u);
}

function h(t, n, i) {
  var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
  var u = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "abbr";
  var e = s(n, i);
  return f(t, r(n, i, e), e, o, u);
}

function x(t, n, i) {
  var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
  var u = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "abbr";
  var e = c(n, i);
  return f(t, r(n, i, e), e, o, u);
}

function d(t, n) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  var o = r(t, n, "degrees"),
      u = o - Math.floor(o);
  o -= u, u *= 60;
  var e = u - Math.floor(u);
  return u -= e, e *= 60, "".concat(o.toFixed(), "\xB0 ").concat(u.toFixed(), "' ").concat(e.toFixed(i), "\"");
}

function p(t, n) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  var o = r(t, n, "degrees");
  return m(o, {
    style: "unit",
    unitDisplay: "narrow",
    unit: "degree",
    maximumFractionDigits: i,
    minimumFractionDigits: i
  });
}

var D = ["B", "kB", "MB", "GB", "TB"];

function M(i, r) {
  var o = 0 === r ? 0 : Math.floor(Math.log(r) / Math.log(1024));
  o = t(o, 0, D.length - 1);
  var u = m(r / Math.pow(1024, o), {
    maximumFractionDigits: 2
  });
  return n(i.units.bytes[D[o]], {
    fileSize: u
  });
}

export { p as formatAngleDegrees, d as formatDMS, f as formatDecimal, M as formatFileSize, x as formatImperialArea, g as formatImperialLength, F as formatImperialVerticalLength, h as formatMetricArea, b as formatMetricLength, l as formatMetricVerticalLength, a as unitName };